import { PasswordInput as UiPasswordInput, type PasswordInputProps } from '@ui';
import { useTranslation } from 'react-i18next';

/** Password input with reveal button and sensible defaults for password managers. */
export function PasswordInput(props: Omit<PasswordInputProps, 'showLabel'>) {
  const { t } = useTranslation();
  return <UiPasswordInput showLabel={t('auth.showPassword')} {...props} />;
}
